import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onAddNewBadge }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-blue-900 to-purple-900 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-6">
        {/* Icon */}
        <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-8">
          <Icon name="Award" size={40} className="text-blue-200" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-heading font-bold text-white mb-4">
          No Badges Yet
        </h2>

        {/* Description */}
        <p className="text-blue-100 font-body mb-8 leading-relaxed">
          Start building your achievement system by creating your first badge. 
          Badges help motivate and recognize user accomplishments.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="default"
            onClick={onAddNewBadge}
            iconName="Plus"
            iconPosition="left"
            className="bg-white text-indigo-900 hover:bg-gray-100 rounded-lg"
          >
            Create First Badge
          </Button>
          
          <Button
            variant="outline"
            onClick={() => window.location?.reload()}
            iconName="RefreshCw"
            iconPosition="left"
            className="border-white text-white hover:bg-white hover:text-indigo-900 rounded-lg"
          >
            Refresh Page
          </Button>
        </div>

        {/* Help Text */}
        <div className="mt-8 p-4 bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-lg">
          <p className="text-sm text-blue-200">
            💡 <strong className="text-blue-100">Tip:</strong> Consider creating badges for different achievement types like learning milestones, streaks, or special accomplishments.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;